import { render, staticRenderFns } from "./AppTopInfo.vue?vue&type=template&id=bcf3afa0&"
import script from "./AppTopInfo.vue?vue&type=script&lang=js&"
export * from "./AppTopInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppTopInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
